<template>
  <div class="checkadrescontainer">
    <div class="chatitle">
      <div class="chaleft aliocen">
        <div class="lincircl">
          <span>1</span>
        </div>
        <span>選擇自提點取貨並下單</span>
      </div>
      <div class="charight aliocen">
        <div class="lincircl">
          <span>2</span>
        </div>
        <span>到自提點取貨</span>
      </div>
    </div>
    <md-field>
      <md-input-item
        ref="input0"
        title="收件人"
        v-model="name"
        placeholder="收件人姓名"
        is-amount
      ></md-input-item>
      <md-input-item
        ref="input0"
        title="联系电话"
        v-model="mobile"
        placeholder="收件人联系电话"
        is-amount
      ></md-input-item>
      <div class="clel">
        <span style="font-size: 0.3rem">超商品牌</span>
        <md-button size="small" inline style="background-color:#f2f2f2;margin-right: 10px" @click="geturl(2)">711</md-button>
        <md-button size="small" inline style="background-color:#f2f2f2;margin-right: 10px" @click="geturl(1)">全家</md-button>
      </div>
    </md-field>
    <div class="adreslist">
      <p style="text-align: left;font-size: 0.4rem;padding-left: 0.3rem;margin-bottom: 0.2rem">我的自提點</p>
      <div class="pacontainer" v-for="(item,index) in list" :key="index" @click="chek(item.id)">
        <div class="listtitle">
          <span style="margin: 0 0.2rem">{{item.name}}</span>
          <span style="margin-right: 0.1rem">{{item.mobile}}</span>
          <div class="divcart" v-if="index==0"><span>最近使用</span></div>
        </div>
        <div class="lisspan">
          <div class="divcirle">
            <span v-if="item.mallBrand==1">全家</span>
            <span v-if="item.mallBrand==2">711</span>
          </div>
          <p><span>{{item.countryName}} {{item.provinceName}} {{item.cityName}} {{item.areaName}}  {{item.address}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {InputItem, Field, Button, Toast} from 'mand-mobile'
  import eventBus from '../../until/eventBus'
  export default {
    name: "checkadres",
    components: {
      [InputItem.name]: InputItem,
      [Field.name]: Field,
      [Button.name]: Button,
    },
    data() {
      return {
        name: '',
        mobile: '',
        list: []
      }

    },
    activated() {
      Toast.loading('加载中...')
      this.getmallList()
    },
    methods: {
      chek(id) {
        localStorage.setItem('chajkskl', id)
        var that = this
        setTimeout(function () {
          that.$router.go(-1)
        }, 100)
      },
      getmallList() {
        this.http.APIASK(this.ports.mallList, 'get',).then(res => {
          this.list = res
          console.log(res)
          Toast.hide()
        }).catch(err => {
          this.loading = false
        })
      },
      geturl(index) {
        if (!this.name) {
          Toast.failed('請輸入收件人姓名')
          return
        }
        if (!this.mobile) {
          Toast.failed('請輸入收件人联系电话')
          return
        }
        this.hasMallInfo(index)
      },
      hasMallInfo(index) {
        const par = {
          type: index
        }
        this.http.APIASK(this.ports.getMallInfo, 'post', par).then(res => {
          let ids=JSON.parse(this.$route.query.ids);
          let url = this.name + 'apple' + this.mobile +  'appleurl' +ids.join('packid');
          if (index == 1) {
            console.log(res+'&cvstemp=' + url)
            window.location.replace(res+'&cvstemp=' + url);
          } else {
            let ids=JSON.parse(this.$route.query.ids);
            let otheriurl = this.name + 'apple' + this.mobile + 'apple' + JSON.parse(localStorage.getItem('userinfoMobie')).id + 'apple' +ids.join('packid');
            window.location.replace(res+'&tempvar=' + otheriurl);
          }
        }).catch(err => {
          this.loading = false
        })
      },
    }
  }
</script>

<style lang="less">
  .checkadrescontainer {
    .md-field-item-title:before {
      content: "*";
      color: #e51c23;
    }


    .chatitle {
      width: 100%;
      background-color: white;
      display: flex;
      align-items: center;
    }

    .clel {
      display: flex;
      height: 0.6rem;
      align-items: center;
      justify-content: flex-start;
      padding-top: 0.3rem;

      span {
        margin-right: 0.5rem;
      }
    }

    .aliocen {
      padding-top: 0.5rem;
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      margin-left: 0.4rem;

      .lincircl {
        margin-right: 0.1rem;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        background-color: #ff5257;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 0.3rem;
      }
    }

    .adreslist {
      width: 98%;
      background-color: white;
      padding: 0.1rem 1%;
    }

    .pacontainer {
      background-color: rgba(255, 255, 255, 1);
      color: rgba(16, 16, 16, 1);
      box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
      margin-bottom: 0.2rem;
      border-radius: 0.1rem;
      width: 94%;
      margin-left: 3%;

      .listtitle {
        display: flex;
        font-size: 0.3rem;
        height: 0.8rem;
        align-items: center;
        flex-wrap: wrap;

        .divcart {
          padding: 0.1rem 0.15rem;
          background-color: #e51c23;
          font-size: 0.24rem;
          color: white;
          border-radius: 0.1rem;
        }

      }

      .lisspan {
        display: flex;
        font-size: 0.3rem;
        height: 0.8rem;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;

        .divcirle {
          padding: 0.1rem 0.2rem;
          background-color: #e2e4ea;
          margin: 0 0.2rem;
        }

        p {
          width: 75%;
          text-align: left;
          margin-right: 2%;
        }
      }
    }
  }
</style>
